export const SET_ID = (state, value) => {
  state.id = value
}

export const SET_TYPE = (state, value) => {
  state.type = value
}

export const SET_RESIDENCE = (state, value) => {
  state.residence = value
}

export const SET_TRADENAME = (state, value) => {
  state.tradeName = value
}

export const SET_NAME = (state, value) => {
  state.name = value
}

export const SET_LASTNAME = (state, value) => {
  state.lastName = value
}

export const SET_DOCUMENT = (state, value) => {
  state.document = value
}

export const SET_SOURCE = (state, value) => {
  state.source = value
}

export const SET_CONTRACT_REFERENCE = (state, value) => {
  state.contractReference = value
}

export const SET_MERCANTILE_REGISTRY = (state, value) => {
  state.mercantileRegistry = value
}

export const SET_ADDITIONAL_INFO = (state, value) => {
  state.additionalInfo = value
}
export const SET_ADDITIONAL_INFOSTORE = (state, value) => {
  if (value) state.rawadditionalInfo = value.reduce((prev, current) => ({...prev, [current.key]: current.value}), {})
  else state.rawadditionalInfo = undefined
}

export const SET_PROP_ADD_INFO = (state, value) => {
  state.additionalInfo.map(x => {
    if (x.key !== value.name) return x
    x.value = value.value
    return x
  })
  state.rawadditionalInfo[value.name] = value.value
}

export const SET_OPERATION_NUMBER = (state, value) => {
  state.rawadditionalInfo.operationNumber = value
}

export const SET_SERVICE_TYPE = (state, value) => {
  state.rawadditionalInfo.serviceType = value
}

export const SET_VALUE = (state, value) => {
  state.loaded = value
}

export const SET_HASCONTACTMEDIUM = (state, value) => {
  state.hasContactMedium = value
}

export const SET_HASCONTRACTREFERENCE = (state, value) => {
  state.hasContractReference = value
}

export const SET_HASCUSTOMINVOICE = (state, value) => {
  state.hasCustomInvoice = value
}

export const SET_DIRTYPE = (state, value) => {
  state.dirType = value
}

export const SET_ISCONTRACTREFERENCEMANDATORY = (state, value) => {
  state.isContractReferenceMandatory = value
}
